import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleHints = () => {
  const roleHints = [
    {
      role: 'Admin',
      email: 'admin@intime.com',
      password: 'admin123',
      description: 'Full system access and user management',
      icon: 'Shield',
      color: 'text-primary'
    },
    {
      role: 'Hiring Manager',
      email: 'manager@intime.com',
      password: 'manager123',
      description: 'Oversee recruitment and final hiring decisions',
      icon: 'Users',
      color: 'text-accent'
    },
    {
      role: 'Recruiter',
      email: 'recruiter@intime.com',
      password: 'recruiter123',
      description: 'Manage candidates and screening process',
      icon: 'Search',
      color: 'text-secondary'
    },
    {
      role: 'Candidate',
      email: 'candidate@intime.com',
      password: 'candidate123',
      description: 'Apply for positions and track applications',
      icon: 'User',
      color: 'text-warning'
    }
  ];

  return (
    <div className="mt-8 p-6 bg-muted/30 rounded-lg border border-border">
      <h3 className="text-sm font-medium text-foreground mb-4 flex items-center space-x-2">
        <Icon name="Info" size={16} />
        <span>Demo Login Credentials</span>
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {roleHints?.map((hint) => (
          <div key={hint?.role} className="p-3 bg-card rounded-md border border-border/50">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name={hint?.icon} size={14} className={hint?.color} />
              <span className="text-xs font-medium text-foreground">{hint?.role}</span>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground font-mono">{hint?.email}</p>
              <p className="text-xs text-muted-foreground font-mono">{hint?.password}</p>
              <p className="text-xs text-muted-foreground">{hint?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-warning/10 border border-warning/20 rounded-md">
        <div className="flex items-start space-x-2">
          <Icon name="AlertTriangle" size={14} className="text-warning mt-0.5" />
          <p className="text-xs text-warning">
            These are demo credentials for testing purposes only. In production, use your actual login credentials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleHints;